window.Styxie.Initializers.MainPage = {
  show: () => {
  }
}
